import {
  AppleEnhancedDesignFeaturedActions,
  FeaturedAction,
  FeaturedActionSlotKey,
  FeaturedActionType,
} from '../../../../store/types/template';

export const FEATURED_ACTION_SLOT_KEYS: FeaturedActionSlotKey[] = [
  'one',
  'two',
];

export const isFeaturedActionSlotFilled = (action: FeaturedAction) =>
  action.type !== null || action.url !== '';

export const createEmptyFeaturedAction = (): FeaturedAction => ({
  type: null,
  url: '',
});

export const createEmptyFeaturedActions =
  (): AppleEnhancedDesignFeaturedActions => ({
    one: createEmptyFeaturedAction(),
    two: createEmptyFeaturedAction(),
  });

export const featuredActionsEqual = (
  a: Record<FeaturedActionSlotKey, FeaturedAction>,
  b: Record<FeaturedActionSlotKey, FeaturedAction>
) =>
  FEATURED_ACTION_SLOT_KEYS.every(
    (slot) => a[slot].type === b[slot].type && a[slot].url === b[slot].url
  );

export const FEATURED_ACTION_TYPES: FeaturedActionType[] = [
  'viewSchedule',
  'watchTrailer',
  'listenToMusic',
  'call',
  'place',
  'addToBalance',
  'order',
  'shop',
  'membershipBenefits',
  'bookAppointment',
  'bookCar',
  'bookFlight',
  'bookStay',
  'viewOffersRewards',
];

export const FEATURED_ACTION_LABELS: Record<FeaturedActionType, string> = {
  viewSchedule: 'View Schedule',
  watchTrailer: 'Watch Trailer',
  listenToMusic: 'Listen to Music',
  call: 'Call',
  place: 'Go to Location',
  addToBalance: 'Add to Balance',
  order: 'Order Delivery or Pickup',
  shop: 'Shop Online or In-App',
  membershipBenefits: 'View Membership Benefits',
  bookAppointment: 'Book an Appointment',
  bookCar: 'Book a Car',
  bookFlight: 'Book a Flight',
  bookStay: 'Book a Stay',
  viewOffersRewards: 'View Offers and Rewards',
};
